import { EdgeDevice } from "./edgeDeviceInterfaces";
import { WireGuardTunnel } from "./wireGuardTunnelsInterfaces";

export const findMatchingWireguardTunnel = (
  device: EdgeDevice,
  tunnels: WireGuardTunnel[]
): WireGuardTunnel | null => {
  const tunnelRef = device.tunnel;
  if (!tunnelRef) {
    return null;
  }

  if (tunnelRef.tunnel_id != null) {
    const matchedById = tunnels.find((tunnel) => tunnel.id === tunnelRef.tunnel_id);
    if (matchedById) {
      return matchedById;
    }
  }

  const tunnelName = tunnelRef.tunnel_name?.trim();
  if (!tunnelName) {
    return null;
  }

  return tunnels.find((tunnel) => tunnel.name === tunnelName) ?? null;
};
